import React from "react";
import {Dropdown, Icon, IDropdownStyles} from '@fluentui/react';
import { renderDate } from "../../../helpers/HelperMethods";

let extension = [{key:0, text: 'No extension'}, { key:1, text: '1 year extension', days: 1}, {key:2,text:'2 years extension'}]

const warningIcon = <div className='warning warning-extension' title="Site needs to be extended to perform any changes">
                        <Icon iconName="Warning"/>
                    </div>

class ExpirationDay extends React.Component {

    change(e,v)
    {
        const res = v.key === 0 ? null : v.key;
        this.props.onUpdate('extension', res);
    }

    render() {

        const warning = new Date(this.props.expirationDate) < Date.now() && !this.props.extension && !this.props.keepReadOnly
            ? warningIcon 
            : null;

        return (
            <div>
                Expiration end date: <span  style={{color: 'blue'}}> {renderDate(this.props.expirationDate)}</span>
                <div style={{marginTop:'10px', position: 'relative'}}>
                    Request for extension
                    <Dropdown
                        placeholder="Choose extension"
                        onChange={this.change.bind(this)}
                        disabled={this.props.disabled || this.props.isreadonly}
                        selectedKey={this.props.extension}
                        options={extension}
                        styles={dropdownStyles}
                    />
                    {warning}
                </div>
            </div>
        );
    }
}
export default ExpirationDay;


const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 200, marginTop:10 }
};


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/ExpirationDay.js